/**
 * Извлекает метаданные видео из ссылки Rutube/YouTube.
 * @param {string} url
 * @returns {{ platform: 'rutube'|'youtube'|null, id: string|null, privateKey: string|null, embedUrl: string|null, thumbnailUrl: string|null }}
 */
export function parseVideoUrl(url) {
  const empty = {
    platform: null,
    id: null,
    privateKey: null,
    embedUrl: null,
    thumbnailUrl: null,
  };

  if (!url || typeof url !== 'string') return empty;

  const trimmed = url.trim();

  const rutubePrivateMatch = trimmed.match(
    /rutube\.ru\/video\/private\/([a-f0-9]+)(?:\/|\?|$)/i
  );
  if (rutubePrivateMatch) {
    const id = rutubePrivateMatch[1];
    const pMatch = trimmed.match(/[?&]p=([^&]+)/i);
    const privateKey = pMatch ? pMatch[1] : null;
    const embedUrl = privateKey
      ? `https://rutube.ru/play/embed/${id}/?p=${encodeURIComponent(privateKey)}`
      : `https://rutube.ru/play/embed/${id}/`;
    return { platform: 'rutube', id, privateKey, embedUrl, thumbnailUrl: null };
  }

  const rutubeMatch = trimmed.match(/rutube\.ru\/(?:video|play\/embed)\/([a-f0-9]+)/i);
  if (rutubeMatch) {
    const id = rutubeMatch[1];
    return {
      platform: 'rutube',
      id,
      privateKey: null,
      embedUrl: `https://rutube.ru/play/embed/${id}/`,
      thumbnailUrl: null,
    };
  }

  const ytWatchMatch = trimmed.match(
    /(?:youtube\.com\/watch\?.*v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/
  );
  if (ytWatchMatch) {
    const id = ytWatchMatch[1];
    return {
      platform: 'youtube',
      id,
      privateKey: null,
      embedUrl: `https://www.youtube.com/embed/${id}`,
      thumbnailUrl: `https://img.youtube.com/vi/${id}/mqdefault.jpg`,
    };
  }

  return empty;
}

/**
 * Преобразует ссылку Rutube/YouTube в embed-URL для iframe.
 * @param {string} url
 * @returns {string|null}
 */
export function toEmbedUrl(url) {
  return parseVideoUrl(url).embedUrl;
}

/**
 * Загружает URL миниатюры Rutube через публичный API.
 * @param {string} videoId
 * @returns {Promise<string|null>}
 */
export async function fetchRutubeThumbnail(videoId) {
  if (!videoId) return null;
  try {
    const res = await fetch(`https://rutube.ru/api/video/${videoId}/`);
    if (!res.ok) return null;
    const data = await res.json();
    return data.thumbnail_url || data.thumbnail_uri || null;
  } catch {
    return null;
  }
}
